import { UserRole } from "../types/api";
import { useOktaAuth } from "../providers/okta-auth-provider";

interface UseAuthorizationResult {
  isAdmin: boolean;
  checkRole: (role: UserRole) => boolean;
  checkPermission: (permission: string) => boolean;
  checkRoles: (roles: UserRole[]) => boolean;
  checkPermissions: (permissions: string[]) => boolean;
  canAccess: (config: { roles?: UserRole[], permissions?: string[] }) => boolean;
}

export function useAuthorization(): UseAuthorizationResult {
  const { userInfo, checkIsUserInRole, checkHasPermission, checkAccess } = useOktaAuth();
  
  const isAdmin = checkIsUserInRole([UserRole.Admin]);
  
  // Controllo per un singolo ruolo
  const checkRole = (role: UserRole): boolean => {
    return checkIsUserInRole([role]);
  };
  
  // Controllo per un singolo permesso
  const checkPermission = (permission: string): boolean => {
    return checkHasPermission([permission]);
  };
  
  // Controllo per una lista di ruoli (verifica se l'utente ha almeno uno)
  const checkRoles = (roles: UserRole[]): boolean => {
    return checkIsUserInRole(roles);
  };
  
  // Controllo per una lista di permessi (verifica se l'utente ha almeno uno)
  const checkPermissions = (permissions: string[]): boolean => {
    return checkHasPermission(permissions);
  };
  
  // Controllo combinato di ruoli e permessi
  const canAccess = (config: { roles?: UserRole[], permissions?: string[] }): boolean => {
    return checkAccess(config.roles || [], config.permissions || []);
  };
  
  return {
    isAdmin,
    checkRole,
    checkPermission,
    checkRoles,
    checkPermissions,
    canAccess
  };
}